import api from "@/services/api";

export const state = {
  countries: [],
  country: {},
};

export const mutations = {
  INIT_COUNTRIES(state, payload) {
    state.countries = payload;
  },
  INIT_COUNTRY(state, payload) {
    state.country = payload;
  },
};

export const actions = {
  getCountries({ commit }, payload) {
    return api.getCountries(payload).then((response) => {
      commit("INIT_COUNTRIES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getCountryById({ commit }, payload) {
    return api.getCountryById(payload).then((response) => {
      commit("INIT_COUNTRY", response.data.data);
    });
  },
};

export const getters = {
  getCountries: (state) => state.countries,
  getCountry: (state) => state.country,
};
